'use strict';

var React = require('react');

/**
 * withEither React HOC Helper
 * @param {*} conditionalRenderingFn
 * @param {*} EitherComponent
 */
var withEither = function withEither(conditionalRenderingFn, EitherComponent) {
  return function (Component) {
    return function (props) {
      return conditionalRenderingFn(props) ? React.createElement(EitherComponent, props) : React.createElement(Component, props);
    };
  };
};

module.exports = withEither;